/**
 * Bundle Category URLs
 * 
 * Maps bundle IDs to category-level Chewy URLs for hero cards.
 * Hero cards should link to the main category page, not specific products.
 */

export const BUNDLE_CATEGORY_URLS: Record<string, string> = {
  walk_essentials: 'https://www.chewy.com/b/dog-leashes-and-collars-344', // "All Collars & Harnesses"
  health_wellness: 'https://www.chewy.com/b/vitamins-supplements-374', // "All Supplements & Vitamins"
  toys: 'https://www.chewy.com/b/toys-315', // "All Dog Toys"
  food_nutrition: 'https://www.chewy.com/b/food-332', // "All Dog Food"
  beds_furniture: 'https://www.chewy.com/b/dog-beds-365', // "All Dog Beds"
}

/**
 * Get category-level URL for a bundle
 * Returns the main category page URL for hero cards
 */
export function getBundleCategoryUrl(bundleId: string | undefined): string | null {
  if (!bundleId) return null
  
  // Normalize bundle ID (handle both hyphen and underscore formats)
  const normalized = String(bundleId)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9_]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '')
  
  return BUNDLE_CATEGORY_URLS[normalized] || null
}

